import React from "react";
import dynamic from "next/dynamic";
import Script from "next/script";
import { IPaymentGateways } from "./IPaymentGateways.interface";
import { GATEWAYS_ENUM } from "../../Payments.constants";

const Stripe = dynamic(() => import("../Stripe/Stripe"), {
    ssr: false,
});

const PaymentGateways = (props: IPaymentGateways) => {
    const { loadPaymentGateways, paymentGatewayConfig } = props;

    if (!loadPaymentGateways) {
        return <></>;
    }

    /**
     * We only load the gateway which will be used by the user, there is no need to
     * render all the gateways that are not going to be required which is what happens
     * in the previous flow in event page.
     * Backend will be providing with the payment gateway that needs to
     * be loaded in this component
     */
    return (
        <>
            {paymentGatewayConfig.map(([gateway, config]) => {
                switch (gateway) {
                    case GATEWAYS_ENUM.STRIPE: {
                        return (
                            <Stripe
                                paymentGatewayDetails={config}
                                key={gateway}
                            />
                        );
                    }
                    case GATEWAYS_ENUM.RAZORPAY: {
                        return (
                            <Script
                                key={config.sourceUrl}
                                src={config.sourceUrl}
                                strategy="afterInteractive"
                            />
                        );
                    }
                    default: {
                        /**
                         * For JusPay and TazaPay we open the url in a new tab which
                         * is provided by backend, so need to load anything here
                         */
                        return null;
                    }
                }
            })}
        </>
    );
};

export default PaymentGateways;
